
import {
  langFlag
} from "../../config/project"
import { setItem } from "@/utils/localStorage";
import i18n, { getLanguage } from "@/lang/index";
// 与 lang/index.js 共用同一推断链，避免两处默认值不一致
let lang = getLanguage()
const store = {
  state: {
    isShowConfig: false,
    deviceInfo: {
      type: "PC",
      innerWidth: 0,
    },
    lang,
    model:""
  },
  mutations: {
    TOGGLE_SHOW_CONFIG(state, val) {
      state.isShowConfig = val;
    },
    SET_DEVICE_INFO(state, val) {
      state.deviceInfo = val;
    },
    SET_LANG(state, val) {
      setItem(langFlag, val);
      state.lang = val;
    },
    SET_MODEL(state, val) {
      state.model = val;
    },
  },
  actions: {
    getDeviceInfo({
      commit
    }) {
      let deviceInfo = {
        type: "PC",
        innerWidth: 0
      }
      if (window.innerWidth <= 480) {
        deviceInfo.type = 'MOBIE'
        deviceInfo.innerWidth = window.innerWidth
      } else {
        deviceInfo.type = 'PC'
        deviceInfo.innerWidth = window.innerWidth
      }
      commit("SET_DEVICE_INFO", deviceInfo)
    },
    setLanguage({ commit }, val) {
      commit("SET_LANG", val);
      i18n.locale = val; // vue-i18n 响应式热切换，视图自动重渲染，无需 reload
    }
  }
}
export default {
  namespaced: true,
  ...store
}